import { render, staticRenderFns } from "./V2ShipmentAction.vue?vue&type=template&id=20467fc6&scoped=true&"
import script from "./V2ShipmentAction.vue?vue&type=script&lang=js&"
export * from "./V2ShipmentAction.vue?vue&type=script&lang=js&"
import style0 from "./V2ShipmentAction.vue?vue&type=style&index=0&id=20467fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20467fc6",
  null
  
)

export default component.exports